var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.priority)?_c('v-chip',{attrs:{"color":_vm.chipColor,"small":"","outlined":!_vm.priority}},[_c('span',{staticClass:"blue-grey--text text--darken-3"},[_vm._v(_vm._s(_vm.$t(`rev.priority.${_vm.priority || 'none'}`)))])]):_c('div',{staticClass:"text-start"},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }